import { makeStyles } from "@fluentui/react-components";

export const useDocumentReaderToolbarStyles = makeStyles({
  readerHead: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden hidden",
    rowGap: "8px",
    width: "100%",
    boxSizing: "border-box",
  },
  toolbar: {
    justifyContent: "space-between",
    flexWrap: "nowrap",
  },
  searchInput: {
    flexGrow: 1,
  },
});
